import React from 'react';
import { BsInstagram } from 'react-icons/bs';
import { BsTwitter } from 'react-icons/bs';
import { BsLinkedin } from 'react-icons/bs';
import { BsTelegram } from 'react-icons/bs';

const Footer = () => {
  return (
    <footer className="bg-active py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-center mb-12 font-secondary">
          <div className="w-full md:w-1/3 xl:w-1/5 p-6">
            <h2 className="text-lg font-bold text-white">Legal</h2>
            <ul>
              <li><a href="https://surfheim.com/Terms-of-service/" className="text-sm font-medium text-gray-100 hover:text-gray-400">Terms of Service</a></li>
              <li><a href="https://surfheim.com/Privacy-policy/" className="text-sm font-medium text-gray-100 hover:text-gray-400">Privacy Policy</a></li>
              <li><a href="https://surfheim.com/Cookies-and-preferences/" className="text-sm font-medium text-gray-100 hover:text-gray-400">Cookies Preferences</a></li>
              <li><a href="https://surfheim.com/Refund-policy/" className="text-sm font-medium text-gray-100 hover:text-gray-400">Refund Policy</a></li>
            </ul>
          </div>

          <div className="w-full md:w-1/3 xl:w-1/5 p-6">
            <h2 className="text-lg font-bold text-white">Links</h2>
            <ul>
              <li><a href="https://surfheim.com/" className="text-sm font-medium text-gray-100 hover:text-gray-400">Home</a></li>
              <li><a href="https://surfheim.com/About-us/" className="text-sm font-medium text-gray-100 hover:text-gray-400">About us</a></li>
              <li><a href="https://surfheim.com/" className="text-sm font-medium text-gray-100 hover:text-gray-400">Features</a></li>
              <li><a href="https://surfheim.com/Pricing/" className="text-sm font-medium text-gray-100 hover:text-gray-400">Pricing</a></li>
              <li><a href="https://blog.surfheim.com" className="text-sm font-medium text-gray-100 hover:text-gray-400">Blog</a></li>
            </ul>
          </div>

          <div className="w-full md:w-1/3 xl:w-1/5 p-6">
            <h2 className="text-lg font-bold text-white">Tools</h2>
            <ul>
              <li><a href="https://surfheim.com/webrtc-leak/" className="text-sm font-medium text-gray-100 hover:text-gray-400">WebRTC Leak</a></li>
              <li><a href="https://surfheim.com/DNS-leak-test/" className="text-sm font-medium text-gray-100 hover:text-gray-400">DNS Leak</a></li>
              <li><a href="https://surfheim.com/Check-IP/" className="text-sm font-medium text-gray-100 hover:text-gray-400">IP Info</a></li>
            </ul>
          </div>

          <div className="w-full md:w-1/3 xl:w-1/5 p-6">
            <h2 className="text-lg font-bold text-white">Social Media</h2>
            <ul className='flex flex-col gap-y-2.5 pt-2'>
              <li><a href="https://www.instagram.com/surfheim?igsh=ZDh3ZTkzcGxuMG91" className="text-2xl font-medium text-gray-100 hover:text-gray-400"><BsInstagram /></a></li>
              <li><a href="https://t.me/surfheim" className="text-2xl font-medium text-gray-100 hover:text-gray-400"><BsTelegram /></a></li>
              <li><a href="https://x.com/surfheim" className="text-2xl font-medium text-gray-100 hover:text-gray-400"><BsTwitter /></a></li>
              <li><a href="https://linkedin.com/company/surfheimco" className="text-2xl font-medium text-gray-100 hover:text-gray-400"><BsLinkedin /></a></li>
            </ul>
          </div>

          <div className="w-full md:w-1/3 xl:w-1/5 p-6">
            <h2 className="text-lg font-bold text-white">Contact us</h2>
            <ul>
              <li className="text-sm font-medium text-gray-100 hover:text-gray-400">support@surfheim.com</li>
            </ul>
          </div>

        </div>
        <p className="text-sm font-medium font-secondary text-gray-100">Copyright surfheim &copy; {new Date().getFullYear()} - All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
